// eslint-disable-next-line @typescript-eslint/naming-convention
export const environment = {
    production: true,
};
